import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'
import { deleteNotification } from '@/features/notifications/api/delete-notification'
import { NOTIFICATIONS_QUERY_KEY } from '@/features/notifications/queries/keys'
import type { ApiError } from '@/lib/api/errors'

export function useDeleteNotification() {
  const queryClient = useQueryClient()
  const { t } = useI18n()

  return useMutation({
    mutationFn: deleteNotification,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_QUERY_KEY }),
    onError: (error: unknown) => {
      toast.error((error as ApiError).message || t('notifications.toast.deleteFailed'))
    },
  })
}
